import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'


export interface CategoryOrderAndImageInput {
  id?: GQL_ID
  customer_order?: number
  preview_size?: string
  icon_id?: GQL_ID
  alternative_icon_id?: GQL_ID
  mini_icon_id?: GQL_ID
}

export interface BulkUpdateCategoriesOrderVariables {
  categoriesInfo: CategoryOrderAndImageInput[]
}

export const GQL_MUTATION_BULK_UPDATE_CATEGORIES_ORDER = gql`
  mutation bulkUpdateCategoriesOrder ($categoriesInfo: [CategoryOrderAndImageInput]!) {
    bulkUpdateCategoriesOrder(categoriesInfo: $categoriesInfo)
  }
`

export const useMutateBulkUpdateCategoriesOrder = () => useMutation<boolean, BulkUpdateCategoriesOrderVariables>(
  GQL_MUTATION_BULK_UPDATE_CATEGORIES_ORDER
)